import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header className={`header ${isScrolled ? 'header-scrolled' : ''}`}>
      <div className="header-container">
        <div className="header-logo" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          <img 
            src="https://customer-assets.emergentagent.com/job_keeper-elite/artifacts/0qosaxkh_971B3874-1CF5-4E9F-8857-70C3B9D443B1.png" 
            alt="The Keeper Lab"
            className="logo-image"
          />
        </div>

        {/* Desktop Navigation */}
        <nav className="header-nav desktop-nav">
          <button onClick={() => scrollToSection('story')} className="nav-link">Historia</button>
          <button onClick={() => scrollToSection('services')} className="nav-link">Servicios</button>
          <button onClick={() => scrollToSection('manifesto')} className="nav-link">Manifiesto</button>
          <button onClick={() => scrollToSection('application')} className="nav-link nav-link-cta">Aplicar</button>
        </nav>

        {/* Mobile Menu Button */}
        <button 
          className="mobile-menu-button"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {isMobileMenuOpen && (
        <nav className="mobile-nav">
          <button onClick={() => scrollToSection('story')} className="mobile-nav-link">Historia</button>
          <button onClick={() => scrollToSection('services')} className="mobile-nav-link">Servicios</button>
          <button onClick={() => scrollToSection('manifesto')} className="mobile-nav-link">Manifiesto</button>
          <button onClick={() => scrollToSection('application')} className="mobile-nav-link-cta">Aplicar</button>
        </nav>
      )}
    </header>
  );
};

export default Header;
